import {
    Component,
    OnInit,
    ChangeDetectorRef,
    AfterContentChecked,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { Grn } from "../../../_models/table-models";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";

@Component({
    selector: "app-view-grn",
    templateUrl: "./view-grn.component.html",
    styleUrls: ["./view-grn.component.scss"],
})
export class ViewGrnComponent implements OnInit {
    searchTerm: string = "";
    pods: Grn[] = [];
    responseData: any;
    isError: any;
    isEmpty = false;
    loading = true;
    all = false;
    isSelected = false;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    proof: any;
    poNumber: any;
    comparable: any;
    filterBy: any;
    sessionExpired = false;
    errorMsg = "";
    selectedOption = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private posService: PosService,
        private cdref: ChangeDetectorRef,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.poNumber = this.route.snapshot.params["poNo"];

        const userData = {
            poNumber: this.poNumber,
            action: "list",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fecthPod(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                if (this.responseData.status === "successful") {
                    this.pods = this.responseData.pods.map((r: any) => ({
                        checked: false,
                        ...r,
                    }));
                    this.collectionSize = this.responseData.pods.length;
                    this.refreshPo();

                    let comparable = [];
                    this.pods.forEach((p: any) => {
                        if (p.status === "invoiced") {
                            console.log("Inside");
                            comparable.push(p);
                        }
                    });
                } else {
                    this.loading = false;
                    this.isEmpty = true;
                }
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
            }
        );
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    refreshPo() {
        this.proof = this.pods
            .map((po: any, i: any) => ({ id: i + 1, ...po }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
    }

    onFilter(option: any) {
        this.filterBy = option.target.value;
        this.selectedOption = true;
    }

    onSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;
        console.log(this.searchTerm);

        if (this.searchTerm !== "") {
            if (this.filterBy === "grn_no") {
                this.proof = this.pods.filter((data) =>
                    data.grn_no
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "invoice_number") {
                this.proof = this.pods.filter((data) =>
                    data.invoice_number
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "po_item_line") {
                this.proof = this.pods.filter((data) =>
                    data.po_item_line
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "item_code") {
                this.proof = this.pods.filter((data) =>
                    data.item_code
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else {
                this.proof = this.pods.filter((data) =>
                    data.status
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            }
        } else {
            this.proof = this.pods;
        }
    }

    generalSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            this.proof = this.pods.filter(
                (data) =>
                    data.grn_no
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.invoice_number
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.grn_year
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.po_item_line
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.grn_quantity
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.status
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.grn_delivery_date
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
            );
        } else {
            this.proof = this.pods;
        }
    }
}
